const Sage = window.Sage;
const grecaptcha = window.grecaptcha;

import Form from './form';

export default {
  init() {
    this.events();
    this.institutionEvents();
    this.adminEvents();
    this.displayFilename();
  },

  events() {
    // Scroll to comment form after posting
    if (window.location.hash) {
      let offset = $(window.location.hash).offset().top - 100;

      $('html, body').animate(
        {
          scrollTop: offset,
        },
        500
      );
    }

    // Scroll to comment form after login.
    if (window.location.search) {
      let search = window.location.search.slice(1);
      if (search.includes('login=social')) {
        const offset = $('.post-comments').offset().top - 100;

        $('html, body').animate(
          {
            scrollTop: offset,
          },
          500
        );
      }
    }

    // On load
    $('.post-comment').each((_i, comment) => {
      comment = $(comment);
      const key = comment.data('id');
      const voted = localStorage.getItem(key);
      if (voted) {
        comment.find(`[data-vote-type=${voted}]`).first().addClass('voted');
      }
    });

    // On vote click
    let throttle = null;
    $('.post-comment__btn').on('click', (e) => {
      const btnEl = $(e.currentTarget);
      const commentId = btnEl.closest('.post-comment').data('id');
      const voteType = btnEl.data('vote-type');

      if (!commentId || !voteType) {
        return;
      }

      let vote = 0;
      let removeOpposite = 0;

      // Check if user voted on comment.
      const userVoted = localStorage.getItem(commentId);
      if (userVoted) {
        // voted
        if (userVoted == voteType) {
          // Same type.
          vote = -1;
          localStorage.removeItem(commentId);

          btnEl.toggleClass('voted');
        } else {
          // Opposite type.
          removeOpposite = true;
          vote = 1;
          localStorage.setItem(commentId, voteType);

          btnEl.addClass('voted');
          const oppositeBtnEl = btnEl.siblings('[data-vote-type]');
          oppositeBtnEl.removeClass('voted');
          let votes = parseInt(oppositeBtnEl.children('span').text());
          oppositeBtnEl.children('span').text(votes - 1);
        }
      } else {
        localStorage.setItem(commentId, voteType);
        vote = 1;
        btnEl.addClass('voted');
      }

      let votes = parseInt(btnEl.children('span').text());
      btnEl.children('span').text(votes + vote);

      // return;
      /* eslint-disable */

      // Throttle save.
      clearTimeout(throttle);
      throttle = setTimeout(() => {
        this.handleCommentVote(commentId, voteType, vote, removeOpposite);
      }, 500);
    });

    // On cancel click
    $('.add-comment__cancel').on('click', () => {
      $('.post-comments__form').slideUp();

      $('.post-comments__button--join').removeClass('hidden');
      $('.post-comments__button--logged-in').removeClass('hidden');
      $('.post-comments__buttons--inner').addClass('hidden');

      const commentField = $('.post-comments__form').find(
        'input[name=comment_id]'
      );
      commentField.val(null);
      $('.add-comment__preview-name').text(null);
      $('.add-comment__preview-excerpt').html(null);

      $('.add-comment__preview').addClass('hidden');
    });

    // Join comment click.
    $('.post-comments__button--join').on('click', () => {
      this.showChoice();
    });

    // Not logged in.
    $('.post-comments__button--guest').on('click', () => {
      $('.post-comments__button--join').addClass('hidden');
      $('.post-comments__buttons--inner').addClass('hidden');

      this.showForm();
    });

    // Logged in.
    $('.post-comments__button--logged-in').on('click', () => {
      $('.post-comments__button--logged-in').addClass('hidden');

      this.showForm();
    });

    // Login click.
    $('.post-comments__button--login').on('click', () => {
      // Hide buttons
      $('.post-comments__button--join').addClass('hidden');
      $('.post-comments__buttons--inner').addClass('hidden');
      $('.post-comments__buttons--login').removeClass('hidden');
    });

    // Reply
    $('.post-comment__btn--reply').on('click', (e) => {
      const btnEl = $(e.currentTarget);
      const commentEl = btnEl.closest('.post-comment');

      const data = {
        id: btnEl.data('id'),
        name: commentEl.find('.post-comment__meta-name').text(),
        desc: commentEl.find('.post-comment__text').html(),
      };

      $('html, body').animate(
        {
          scrollTop: $('.post-comments').offset().top,
        },
        500
      );

      if (true != btnEl.data('user')) {
        $('.post-comments__buttons--login').addClass('hidden');
      }

      setTimeout(() => {
        if (true == btnEl.data('user')) {
          this.showForm();
        } else {
          this.showChoice();
        }
      }, 500);

      const commentField = $('.post-comments__form').find(
        'input[name=comment_id]'
      );
      commentField.val(data.id);
      $('.add-comment__preview-name').text(data.name);
      $('.add-comment__preview-excerpt').html(data.desc, 0, 20) + '...';

      $('.add-comment__preview').removeClass('hidden');
    });

    // Form submit
    $('.add-comment').on('submit', (e) => {
      e.preventDefault();
      const formEl = $(e.currentTarget);

      formEl.addClass('loading');
      formEl.find('.form__message').text('');

      if (Form.validate(formEl)) {
        this.recaptcha(formEl);
      } else {
        formEl.removeClass('loading');
      }
    });

    // Hide comments.
    $('.post-comment').each((i, comment) => {
      const perPage = parseInt($('.post-comments').data('per-page'));
      comment = $(comment);
      if (i > perPage) {
        comment.addClass('hidden');
      }
    });

    // Show all.
    $('.post-comments__btn--show-all').on('click', (e) => {
      const btnEl = $(e.currentTarget);
      btnEl.hide();
      $('.post-comment').removeClass('hidden');
    });
  },

  handleCommentVote(commentId, voteType, vote, removeOpposite) {
    const _self = this;

    grecaptcha.ready(function () {
      grecaptcha
        .execute(Sage.recaptcha_site_key, { action: 'submit' })
        .then(function (token) {
          _self.submitCommentVote(
            commentId,
            voteType,
            vote,
            removeOpposite,
            token
          );
        });
    });
  },

  submitCommentVote(commentId, voteType, vote, removeOpposite, token) {
    $.ajax({
      url: Sage.ajaxurl,
      data: {
        action: 'sage_comment_vote',
        comment_id: commentId,
        vote_type: voteType,
        vote,
        remove_opposite: removeOpposite,
        token,
      },
      method: 'POST',
    }).done((response) => {
      if (response.likes) {
        $('.post-comment__btn[data-vote-type=likes]').text(response.likes);
      }
      if (response.dislikes) {
        $('.post-comment__btn[data-vote-type=dislikes]').text(
          response.dislikes
        );
      }
    });
  },

  institutionEvents() {
    // Show institution form.
    $('.add-institution-comment').on('click', (e) => {
      const btn = $(e.currentTarget);
      btn.addClass('hidden');
      $('.institution-add-comment ').removeClass('hidden');
    });

    $('.institution-add-comment__cancel').on('click', () => {
      $('.add-institution-comment').removeClass('hidden');
      $('.institution-add-comment ').addClass('hidden');
    });

    // Institution form submit
    $('.institution-add-comment').on('submit', (e) => {
      e.preventDefault();
      const formEl = $(e.currentTarget);

      formEl.addClass('loading');
      formEl.find('.form__message').text('');

      if (Form.validate(formEl)) {
        this.institutionSubmit(formEl);
      } else {
        formEl.removeClass('loading');
      }
    });
  },

  adminEvents() {
    // Show institution form.
    $('.add-admin-comment').on('click', (e) => {
      const btn = $(e.currentTarget);
      btn.addClass('hidden');
      $('.admin-comment-form').removeClass('hidden');
    });

    $('.admin-comment-form__cancel').on('click', () => {
      $('.add-admin-comment').removeClass('hidden');
      $('.admin-comment-form ').addClass('hidden');
    });

    // Admin form submit
    $('.admin-comment-form').on('submit', (e) => {
      e.preventDefault();
      const formEl = $(e.currentTarget);

      formEl.addClass('loading');
      formEl.find('.form__message').text('');

      if (Form.validate(formEl)) {
        this.adminSubmit(formEl);
      } else {
        formEl.removeClass('loading');
      }
    });
  },

  /**
   * Show choice btns
   */
  showChoice() {
    $('.post-comments__button--join').addClass('hidden');
    $('.post-comments__buttons--inner').removeClass('hidden');
  },

  /**
   * Show form
   */
  showForm() {
    $('.post-comments__form').slideDown();
  },

  /**
   * Recaptcha
   */
  recaptcha(formEl) {
    const _self = this;
    grecaptcha.ready(function () {
      grecaptcha
        .execute(Sage.recaptcha_site_key, { action: 'submit' })
        .then(function (token) {
          _self.submit(formEl, token);
        });
    });
  },

  /**
   * Institution form submit
   */
  institutionSubmit(formEl) {
    let formData = new FormData(formEl[0]);

    $.ajax({
      url: Sage.ajaxurl,
      data: formData,
      processData: false,
      contentType: false,
      method: 'POST',
    })
      .done((response) => {
        if (response.success) {
          const base_url = window.location.origin + window.location.pathname;
          window.location = base_url + '#comment-' + response.data.url;
          window.location.reload();
        } else {
          formEl.removeClass('loading');
        }

        if (response.data.message) {
          formEl.find('.form__message').text(response.data.message);
        }
      })
      .error(() => {
        formEl.removeClass('loading');
      });
  },

  /**
   * Admin form submit
   */
  adminSubmit(formEl) {
    let formData = new FormData(formEl[0]);

    $.ajax({
      url: Sage.ajaxurl,
      data: formData,
      processData: false,
      contentType: false,
      method: 'POST',
    })
      .done((response) => {
        if (response.success) {
          const base_url = window.location.origin + window.location.pathname;
          window.location = base_url + '#comment-' + response.data.url;
          window.location.reload();
        } else {
          formEl.removeClass('loading');
        }

        if (response.data.message) {
          formEl.find('.form__message').text(response.data.message);
        }
      })
      .error(() => {
        formEl.removeClass('loading');
      });
  },

  /**
   * Commenter form submit
   */
  submit(formEl, token) {
    let formData = new FormData(formEl[0]);

    formData.append('token', token);

    const hasUploads = $(".form-field__upload");

    if (hasUploads.length) {
      let fileData = $(".form-field__upload")[0].files;

      $.each(fileData, function (index, file) {
        formData.append("file-" + index, file);
      });
    }

    $.ajax({
      url: Sage.ajaxurl,
      data: formData,
      processData: false,
      contentType: false,
      method: 'POST',
    })
      .done((response) => {
        if (response.success) {
          const base_url = window.location.origin + window.location.pathname;
          window.location = base_url + '#comment-' + response.data.url;
          window.location.reload();
        } else {
          formEl.removeClass('loading');
        }

        if (response.data.message) {
          formEl.find('.form__message').text(response.data.message);
        }
      })
      .error(() => {
        formEl.removeClass('loading');
      });
  },

  /**
   * Gathers all the filenames for uploaded files
  */
  displayFilename() {

    const self = this;

    var uploadedFileNames = [];

    $(document).on("change", ".form-field__upload", function () {
      uploadedFileNames = [];
      var files = $(this)[0].files;

      if (files.length > 3) {
        alert('Jūs varat ielādēt maksimums 3 failus.');
        $(this).val('');
        self.updateFileList([]);
        return;
      };

      for (var i = 0; i < files.length; i++) {
        uploadedFileNames.push(files[i].name);
      };

      self.updateFileList(uploadedFileNames);
    });
  },

  /**
   * Updates the form filelist
  */
  updateFileList(uploadedFileNames) {
    const resultEl = $(".form-field__upload-results");
    resultEl.html('');
    resultEl.removeClass("hidden");

    if (uploadedFileNames.length > 0) {
      for (var i = 0; i < uploadedFileNames.length; i++) {
        var fileName = uploadedFileNames[i];
        var fileSpan = $('<p class="form-field__filename">').text(fileName);
        $(resultEl).append(fileSpan);
      }
    }
  }
};
